<template>
	<el-dialog v-bind="$attrs">
		<slot></slot>
	</el-dialog>
</template>
<script>
export default {
	name: 'modal-generic',
	inheritAttrs: false,
};
</script>




// WEBPACK FOOTER //
// modalGeneric.vue?9f8af97e